import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
import axios from 'axios';

const containsKey = (obj, key) => Object.keys(obj).includes(key);

export async function getChildrenData({ commit, state }, UserId) {
  let to_Response = '';
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${UserId}/getChildren/`,
  })
    .then((response) => {
      commit('setChildrenData', response.data);
      to_Response = response.data;
    })
    .catch((error) => {
      commit('registerError', error.message);
      to_Response = 'error';
    });
  return to_Response;
}

export async function createChild({ commit }, info) {
  try {
    commit('cleanErrors');
    await Vue.axios({
      method: 'POST',
      url: '/register/child/',
      data: {
        name: info.userChildName,
        last_name: info.userChildLastName,
        birthdate: info.userChildBirthday,
        email: info.userChildEmail,
        password: info.userChildPass,
        re_password: info.userChildRePass,
        parent: info.getUserId,
        modulesUnlocked: info.modules,
      },
    })
      .then((response) => {
        commit('incrementChildCount');
        commit('setChildSelectedData', response.data);
      })
      .catch(function(error) {
        commit('registerError', error.response.data[0]);
      });
  } catch (e) {
    commit('registerError', e.message);
  }
}

export async function fecthAllGenders({ commit }) {
  await Vue.axios({
    method: 'GET',
    url: '/gender/',
  })
    .then((response) => {
      commit('saveGenders', response.data);
    })
    .catch((error) => {
      commit('registerError', error.message);
    });
}

export async function passwordRecovery({ commit }, email) {
  await Vue.axios({
    method: 'POST',
    url: '/password-recovery/',
    data: {
      email: email,
    },
  })
    .then((response) => {})
    .catch((error) => {
      commit('registerError', error.message);
    });
}

export async function changeTheme({ commit }, payload) {
  let url = payload.isParent
    ? `/parent/${payload.idUser}/changeTheme/`
    : `/child/${payload.idUser}/changeTheme/`;
  await Vue.axios({
    method: 'POST',
    url: url,
    data: {
      themeSelection: payload.idTheme,
    },
  })
    .then((response) => {
      commit('themeChange', response.data.themeSelection);
    })
    .catch((error) => {
      commit('registerError', error.message);
    });
}

export async function darkModeChange({ commit }, dark) {
  commit('setDarkMode', dark);
}
